<template>
    <div>
        <Nav></Nav>
        <!-- <keep-alive> -->
            <router-view class="main-box"></router-view>
        <!-- </keep-alive> -->
    </div>
</template>
<script>
    import Nav from './nav'
export default {
    components: {
        Nav
    }
}
</script>
<style>
    .main-box {
        /* height: calc(100vh - 70px); */
        padding: 16px;
        max-width: 1366px;
        /* overflow-y: auto; */
        
    }
    @media screen and (min-width: 1366px){
        .main-box {
            margin-right: auto !important;
        margin-left: auto!important;
        }
    }
</style>